/* eslint-disable */
export default {
  recentActivities: '最近のアクティビティ',
  text: 'テキスト',
  fax: 'FAX',
  voicemail: 'ボイスメール',
  call: '通話',
} as const;

// @key: @#@"recentActivities"@#@ @source: @#@"Recent Activities"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"voicemail"@#@ @source: @#@"Voicemail"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
